var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ipsw"},[_c('div',{staticClass:"title"},[_vm._v("固件下载")]),_c('dev'),_vm._v(" "),_c('ipsw-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }